import Swiper, { Navigation, A11y } from 'swiper';
import { SMALL_CAROUSEL_BREAKPOINTS, STANDARD_CAROUSEL_BREAKPOINTS } from './constants';
Swiper.use([Navigation, A11y]);

interface FeaturedEventCarouselProps {
    el: HTMLElement;
}

const FeaturedEventCarousel = ({ el }: FeaturedEventCarouselProps): void => {
    const carousel: HTMLElement | null = el.querySelector('.event-carousel');
    const smallCarousel: HTMLElement | null = el.querySelector('.event-carousel-sm');
    const controlNext: HTMLElement | null = el.querySelector('.carousel-control-next');
    const controlPrev: HTMLElement | null = el.querySelector('.carousel-control-prev');

    const targetCarousel = smallCarousel || carousel;

    if (!targetCarousel || !controlNext || !controlPrev) {
        return;
    }

    const eventCardCarousel = new Swiper(targetCarousel, {
        init: false,
        navigation: {
            nextEl: controlNext,
            prevEl: controlPrev,
        },
        pagination: false,
        breakpoints: smallCarousel
            ? SMALL_CAROUSEL_BREAKPOINTS
            : STANDARD_CAROUSEL_BREAKPOINTS,
    });

    eventCardCarousel.init();
};

export default FeaturedEventCarousel;
